import axios from 'axios'
import store from '@js/store'
import notificationJSON from '@var/notifications.json'
store.dispatch('setConfig',{loaded: false});
var crypto = require('crypto');
export default {

    setConfig() {
        return new Promise((resolve, reject) => {
            if(helper.getConfig('loaded')) {
                resolve()
            } else {
                axios.get('/api/config')
                    .then(response => {
                        console.log(response)
                        store.dispatch('resetConfig');
                        ///response.loaded = true;
                        store.dispatch('setConfig',response);
                        resolve();
                    }).catch(error => {
                        reject(error);
                    })
                .catch(error => {
                    reject(error)
                })  
            }
        })
    },

    // to logout user
    logout(){
        return axios.post('/api/auth/logout').then(response =>  {
            this.clearSession();
            store.dispatch('setConfig',response.config);
            toastr.success(response.message);
        }).catch(error => {
            this.showErrorMsg(error);
        });
    },
    generateHash(reqData){
      var shasum = crypto.createHash('sha512');
      let hash_columns = [];
      let resultKey='';
        //reqData = req.body;
		console.log(reqData)
	if(	reqData.amount && reqData.address_line_1 && reqData.city && reqData.name && reqData.email && reqData.phone && reqData.order_id && reqData.currency && reqData.description && reqData.country && reqData.return_url ){
		hash_columns = [
				"address_line_1",
                "address_line_2",
                "amount",
                "api_key",
                "city",
                "country",
                "currency",
                "description",
                "email",
                "mode",
                "name",
                "order_id",
                "phone",
                "return_url",
                "state",
                "udf1",
                "udf2",
                "udf3",
                "udf4",
                "udf5",
                "zip_code"
				];
				
				
		var hash_data = this.getConfig('aggrepay_salt'); 
		
		hash_columns.forEach(function(entry) {
			if(entry in reqData){
                            console.log(reqData[entry]+' ');
				if(reqData[entry].toString().length > 0 ){
				hash_data += '|' + reqData[entry];
				}		
			}
		});	
                console.log(hash_data)
		resultKey = shasum.update(hash_data).digest('hex').toUpperCase();
		//res.end(JSON.stringify({"data":resultKey}));
                return resultKey;
	}else{
		resultKey = '';
		//res.end(JSON.stringify({"data":resultKey}));
                return resultKey;
	}  
    },
    clearSession(){
        Vue.cookie.delete('auth_token');
        Vue.cookie.delete('school_name');
        Vue.cookie.delete('x-connection-object');
        store.dispatch('resetDefaultAcademicSession');
        store.dispatch('resetAcademicSession');
        store.dispatch('resetAuthUserDetail');
        store.dispatch('resetConfig');
        store.dispatch('setConfig',{loaded: false});
    },

    // to get authenticated user data
    authUser(){
        return axios.get('/api/auth/user').then(response =>  {
            return response;
        }).catch(error => {
            this.showErrorMsg(error);
        });
    },

    // to set notification position
    notification(){
        var notificationPosition = this.getConfig('notification_position') || 'toast-bottom-right';
        toastr.options = {
            "positionClass": notificationPosition
        };
        this.setLastActivity();

        $('[data-toastr]').on('click',function(){
            var type = $(this).data('toastr'),message = $(this).data('message'),title = $(this).data('title');
            toastr[type](message, title);
        });
    },

    setLastActivity(){
        if(!this.isScreenLocked())
            store.dispatch('setLastActivity')
    },

    // to check for last activity time and lock/unlock screen
    isScreenLocked(){
        let last_activity = this.getLastActivity();
        let lock_screen_timeout = this.getConfig('lock_screen_timeout');
        let last_activity_after_timeout = moment(last_activity).add(lock_screen_timeout,'minutes').format('LLL');
        return (moment().format('LLL') > last_activity_after_timeout);
    },
    ConvertWord(WrdAmt){
        let strtemp, strtemp1, NumInWords, intNumber;
        let numbers = ["","One ","Two ","Three ","Four ","Five ","Six ","Seven ","Eight ","Nine ","Ten ","Eleven ","Twelve ","Thirteen ","Fourteen ","Fifteen ","Sixteen ","Seventeen ","Eighteen ","Nineteen ","Twenty ","Twenty One ","Twenty Two ","Twenty Three ","Twenty Four ","Twenty Five ","Twenty Six ","Twenty Seven ","Twenty Eight ","Twenty Nine ","Thirty ","Thirty One ","Thirty Two ","Thirty Three ","Thirty Four ","Thirty Five ","Thirty Six ","Thirty Seven ","Thirty Eight ","Thirty Nine ","Fourty ","Fourty One ","Fourty Two ","Fourty Three ","Fourty Four ","Fourty Five ","Fourty Six ","Fourty Seven ","Fourty Eight ","Fourty Nine ","Fifty ","Fifty One ","Fifty Two ","Fifty Three ","Fifty Four ","Fifty Five ","Fifty Six ","Fifty Seven ","Fifty Eight ","Fifty Nine ","Sixty ","Sixty One ","Sixty Two ","Sixty Three ","Sixty Four ","Sixty Five ","Sixty Six ","Sixty Seven ","Sixty Eight ","Sixty Nine ","Seventy ","Seventy One ","Seventy Two ","Seventy Three ","Seventy Four ","Seventy Five ","Seventy Six ","Seventy Seven ","Seventy Eight ","Seventy Nine ","Eighty ","Eighty One ","Eighty Two ","Eighty Three ","Eighty Four ","Eighty Five ","Eighty Six ","Eighty Seven ","Eighty Eight ","Eighty Nine ","Ninety ","Ninety One ","Ninety Two ","Ninety Three ","Ninety Four ","Ninety Five ","Ninety Six ","Ninety Seven ","Ninety Eight ","Ninety Nine "];
        NumInWords = ""
        intNumber = WrdAmt.length;
        switch(intNumber){
            case 4:
					strtemp = WrdAmt.substring(0, 1);
					strtemp1 = WrdAmt.substring(1);
					if (strtemp!="0"){
						NumInWords = numbers[parseInt(strtemp)] + "Thousand " + this.ConvertWord(strtemp1);	
					}
					else{
						NumInWords = this.ConvertWord(strtemp1);	
					}
					break;
            case 3:
					strtemp = WrdAmt.substring(0 ,1)
					strtemp1 = WrdAmt.substring(1);
					if (strtemp!= "0"){
						NumInWords = numbers[parseInt(strtemp)]+ "Hundred " + this.ConvertWord(strtemp1);	
					}
					else{
						NumInWords = this.ConvertWord(strtemp1);	
					}
					break;
            case 2:
					strtemp = WrdAmt.substring(0,2)
					if (strtemp != "0"){
						NumInWords = numbers[parseInt(strtemp)];	
					}  
					else{
						NumInWords = this.ConvertWord(strtemp1);	
					}
					break;
            case 1:
					strtemp = WrdAmt.substring(1);
					if (strtemp != "0"){
						NumInWords = numbers[parseInt(strtemp)];	
					}  
					break;
            case 0: break;
		}
		return NumInWords;
    },
    convertIntoWords(dateObject){		
		if (Object.prototype.toString.call(dateObject)!="[object Date]"){
			console.log("invalid parameter for dobToWords");
			return ;
		}
        
        let wDays = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth', 'Eleventh', 'Twelfth', 'Thirteenth', 'Fourteenth', 'Fifteenth', 'Sixteenth', 'Seventeenth', 'Eighteenth', 'Nineteenth', 'Twentieth', 'Twenty-First', 'Twenty-Second', 'Twenty-Third', 'Twenty-Fourth', 'Twenty-Fifth', 'Twenty-Sixth', 'Twenty-Seventh', 'Twenty-Eighth', 'Twenty-Ninth', 'Thirtieth', 'Thirty-First'];
        let wMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        let wordString=null;
        let date = dateObject
        let day = parseInt(date.getDate()) - 1;
        let month = parseInt(date.getMonth());
        let year = date.getFullYear();
        let yearString = year.toString();
        //Assign day and month
        wordString=wDays[day] + ' ' + wMonths[month];
        if (year < 2000) {
            wordString = wordString + " " + this.ConvertWord(yearString.substring(0, 2));
            wordString = wordString + this.ConvertWord(yearString.substring(2,4));
        }	
        else{
            wordString = wordString + " " + this.ConvertWord(yearString);
        }
        return wordString;
	},

    // to append filter variables in the URL
    getFilterURL(data){
        let url = '';
        $.each(data, function(key,value) {
            url += (value) ? '&'+key+'='+encodeURI(value) : '';
        });
        return url;
    },

    getLastActivity(){
        return store.getters.getLastActivity;
    },

    // to get Auth Status
    isAuth(){
        return store.getters.getAuthStatus;
    },

    // returns all academic session
    getAcademicSessions(){
        return store.getters.getAcademicSessions;
    },

    // returns all academic session
    getDefaultAcademicSession(){
        return store.getters.getDefaultAcademicSession;
    },

    // to get Auth user detail
    getAuthUser(name){
        if(name === 'full_name')
            return store.getters.getAuthUser('first_name')+' '+store.getters.getAuthUser('last_name');
        else if(name === 'avatar'){
            if(store.getters.getAuthUser('avatar'))
                return '/'+store.getters.getAuthUser('avatar');
            else
                return '/images/avatar.png';
        }
        else
            return store.getters.getAuthUser(name);
    },

    // to get config
    getConfig(config){
        return store.getters.getConfig(config);
    },

    // to get default role name of system
    getDefaultRole(role){
        return store.getters.getDefaultRole(role);
    },

    // to check role of authenticated user
    hasRole(role){
        return store.getters.hasRole(this.getDefaultRole(role));
    },

    // to check any permission for authenticated user
    hasAnyRole(roles){
        return store.getters.hasAnyRole(roles);
    },

    // to check any permission for authenticated user
    hasNotAnyRole(roles){
        return store.getters.hasNotAnyRole(roles);
    },

    // to check permission for authenticated user
    hasPermission(permission){
        return store.getters.hasPermission(permission);
    },

    // to check any permission for authenticated user
    hasAnyPermission(permissions){
        return store.getters.hasAnyPermission(permissions);
    },

    // to check Admin role
    hasAdminRole(){
        if(this.hasRole('admin'))
            return 1;
        else
            return 0;
    },

    // to check whether a given user has given role
    userHasRole(user,role_name){
        if(!user.roles)
            return false;

        let user_role = user.roles.filter(role => role.name === this.getDefaultRole(role_name))
        if(user_role.length)
            return true;
        return false;
    },

    // to check feature is available or not
    featureAvailable(feature){
        return this.getConfig(feature);
    },

    // returns not accessible message if permission is denied
    notAccessibleMsg(){
        toastr.error(i18n.user.permission_denied);
    },

    // returns feature not available message if permission is denied
    featureNotAvailableMsg(){
        toastr.error(i18n.general.feature_not_available);
    },

    getLogo(){
        if(this.getConfig('logo'))
            return '/'+this.getConfig('logo');
        else
            return '/images/default_logo.png';
    },

    getIcon(){
        if(this.getConfig('icon'))
            return '/'+this.getConfig('icon');
        else
            return '/images/default_icon.png';
    },

    // returns user status
    getUserStatus(user){
        let status = [];

        if(user.status === 'activated')
            status.push({'color': 'success','label': i18n.user.status_activated});
        else if(user.status === 'pending_activation')
            status.push({'color': 'warning','label': i18n.user.status_pending_activation});
        else if(user.status === 'pending_approval')
            status.push({'color': 'warning','label': i18n.user.status_pending_approval});
        else if(user.status === 'banned')
            status.push({'color': 'danger','label': i18n.user.status_banned});
        else if(user.status === 'disapproved')
            status.push({'color': 'danger','label': i18n.user.status_disapproved});

        return status;
    },

    // returns registration status
    getRegistrationStatus(registration){
        let status = [];

        if(registration.status === 'pending' || !registration.status)
            status.push({'color': 'warning','label': i18n.student.registration_status_pending});
        else if(registration.status === 'allotted')
            status.push({'color': 'success','label': i18n.student.registration_status_allotted});
        else if(registration.status === 'rejected')
            status.push({'color': 'danger','label': i18n.student.registration_status_rejected});

        return status;
    },

    // returns leave status
    getLeaveRequestStatus(leave_request){ 
        let status = [];

        if(leave_request.status === 'pending' || !leave_request.status)
            status.push({'color': 'info','label': i18n.employee.leave_request_status_pending});
        else if(leave_request.status === 'approved')
            status.push({'color': 'success','label': i18n.employee.leave_request_status_approved});
        else if(leave_request.status === 'rejected')
            status.push({'color': 'danger','label': i18n.employee.leave_request_status_rejected});
        else if(leave_request.status === 'cancelled')
            status.push({'color': 'warning','label': i18n.employee.leave_request_status_cancelled});

        return status;
    },

    // returns payroll status
    getPayrollStatus(payroll){
        let status = [];

        if(payroll.payment_status === 'unpaid' || !payroll.payment_status)
            status.push({'color': 'danger','label': i18n.employee.payroll_status_unpaid});
        else if(payroll.payment_status === 'partially_paid')
            status.push({'color': 'warning','label': i18n.employee.payroll_status_partially_paid});
        else if(payroll.payment_status === 'paid')
            status.push({'color': 'success','label': i18n.employee.payroll_status_paid});

        return status;
    },

    // returns enquiry status
    getEnquiryStatus(enquiry){
        let status = [];

        if(enquiry.status === 'open' || !enquiry.status)
            status.push({'color': 'info','label': i18n.reception.enquiry_status_open});
        else if(enquiry.status === 'missed')
            status.push({'color': 'danger','label': i18n.reception.enquiry_status_missed});
        else if(enquiry.status === 'partially_closed')
            status.push({'color': 'warning','label': i18n.reception.enquiry_status_partially_closed});
        else if(enquiry.status === 'closed')
            status.push({'color': 'success','label': i18n.reception.enquiry_status_closed});

        return status;
    },

    // returns vehicle document status
    getVehicleDocumentStatus(document){
        if (moment(document.date_of_expiry,'YYYY-MM-DD').startOf('day') < moment().startOf('day'))
            return {status: 'vehicle_document_status_expired', color:'danger', day: 0};
        else {
            let today = moment().startOf('day');
            let expiry_date = moment(document.date_of_expiry,'YYYY-MM-DD').startOf('day');
            let day = expiry_date.diff(today, 'days');

            let color = '';
            if (day < 15) {
                color = 'warning';
            } else {
                color = 'success';
            }

            return {status: 'vehicle_document_status_expire_in_day', color:color, day: day};
        }
    },

    getDateDiff(date1, date2){
        if (date2 == 'undefined') 
            date2 = moment().startOf('day');

        date1 = moment(date1,'YYYY-MM-DD').startOf('day');
        let day = date1.diff(date2, 'days');
        return Math.abs(day);
    },

    getLateFee(fee_installment, late_day){
        let per_period = Math.floor(late_day / fee_installment.late_fee_frequency);
        return fee_installment.late_fee * per_period;
    },

    getLateFeeFrequencyIntoNumber(frequency){
        if(frequency == 'daily')
            return 1;
        else if(frequency == 'weekly')
            return 7;
        else if(frequency == 'fortnightly')
            return 15;
        else if(frequency == 'monthly')
            return 30;
        else if(frequency == 'bi_monthly')
            return 60;
        else if(frequency == 'quarterly')
            return 90;
        else if(frequency == 'bi_annually')
            return 180;
        else if(frequency == 'annually')
            return 365;
        else
            return 1;
    },

    // to mass assign one object in another object
    formAssign(form, data){
        for (let key of Object.keys(form)) {
            if(key !== "originalData" && key !== "errors" && key !== "autoReset" && key !== "providers"){
                form[key] = data[key] || '';
            }
        }
        return form;
    },

    // to get date in desired format
    formatDate(date){
        if(!date)
            return;

        return moment(date).format(this.getConfig('date_format'));
    },

    // to get date in desired format
    defaultDate(){
        return moment(new Date).format(this.getConfig('date_format'));
    },

    // to get date time in desired format
    formatDateTime(date){
        if(!date)
            return;

        var date_format = this.getConfig('date_format');
        var time_format = this.getConfig('time_format');

        return moment(date).format(date_format+' '+time_format);
    },

    // to get time in desired format
    defaultDateTime(){
        return moment(new Date).format(this.getConfig('date_format')+' '+this.getConfig('time_format'));
    },

    // to get time in desired format
    formatTime(time){
        if(!time)
            return;

        var time_format = this.getConfig('time_format');
        let date = moment().format('YYYY-MM-DD')+' '+time;

        return moment(date).format(time_format);
    },

    // to get time in desired format
    defaultTime(){
        return moment(new Date).format(this.getConfig('time_format'));
    },

    // to get time from now
    formatDateTimeFromNow(datetime){
        if(!datetime)
            return;

        return moment(datetime).fromNow();
    },

    toDate(date){
        return date ? moment(date).format('YYYY-MM-DD') : '';
    },

    toTime(time){
        return (time.hour) ? helper.formatWithPadding(time.hour,2)+':'+helper.formatWithPadding(time.minute,2)+' '+time.meridiem : '';
    },

    // to change first character of every word to upper case
    ucword(value){
        if(!value)
            return;

        return value.toLowerCase().replace(/\b[a-z]/g, function(value) {
            return value.toUpperCase();
        });
    },

    // to change string into human readable format
    toWord(value){
        if(!value)
            return;

        value = value.replace(/-/g, ' ');
        value = value.replace(/_/g, ' ');

        return value.toLowerCase().replace(/\b[a-z]/g, function(value) {
            return value.toUpperCase();
        });
    },

    createSlug(value){
        return value.toLowerCase()
                    .replace(/\s+/g, '-') // Replace spaces with
                    .replace(/&/g, '-and-') // Replace & with ‘and’
                    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                    .replace(/\-\-+/g, '-') // Replace multiple — with single -
                    .replace(/^-+/, '') // Trim — from start of text .replace(/-+$/, '');
    },

    // shows toastr notification for axios form request
    showErrorMsg(error){
        this.setLastActivity();
        if (error.hasOwnProperty("response")) {
            const statusCode = error.response.status;

            const message = error.response.hasOwnProperty("data") ? error.response.data.message : error.response.message;
            const login = error.response.hasOwnProperty("data") ? error.response.data.login : error.response.login;

            if (statusCode == 400 || statusCode == 401 || statusCode == 403) {
                toastr.error(message);
            } else if(statusCode == 500) {
                toastr.error(i18n.general.something_wrong);
            } else if(statusCode == 422 && error.response.hasOwnProperty("error")) {
                toastr.error(error.response.error);
            } else if(statusCode == 422 && error.response.hasOwnProperty("data")) {
                toastr.error(error.response.data.errors.message[0]);
            } else if(statusCode == 404) {
                toastr.error(i18n.general.invalid_link);
            }

            if (login) {
                this.clearSession();
                location.reload();
            }
        } else if(error.hasOwnProperty("errors")) {
            const message = error.errors.hasOwnProperty("message") ? error.errors.message[0] : '';
            if (message) {
                toastr.error(message);
            }
        } else if(error) {
            toastr.error(error);
        }
    },

    // returns error message for axios form request
    fetchErrorMsg(error){
        return error.errors.message[0];
    },

    // round numbers as given precision
    roundNumber(number, precision){
        precision = Math.abs(parseInt(precision)) || 0;
        var multiplier = Math.pow(10, precision);
        return (Math.round(number * multiplier) / multiplier);
    },

    // round numbers as given precision
    formatNumber(number,decimal_place){
        if (decimal_place === undefined)
            decimal_place = 2;
        return this.roundNumber(number,decimal_place);
    },

    // fill number with padding
    formatWithPadding(n, width, z){
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },

    // generates random string of certain length
    randomString(length) {
        if (length === undefined)
            length = 40;
        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var result = '';
        for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    },

    bytesToSize(bytes) {
       var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
       if (bytes == 0) return '0 Byte';
       var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
       return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },

    formatCurrency(price){
        var currency = helper.getConfig('default_currency');
        let decimal_place = currency.decimal_place || 2;
        if(currency.position === 'prefix')
            return currency.symbol+''+this.roundNumber(price,decimal_place);
        else
            return this.roundNumber(price,decimal_place)+' '+currency.symbol;
    },

    getLateFeeFrequencyName(frequency){
        if (frequency == 1)
            return i18n.finance.late_fee_frequency_daily;
        else if(frequency == 7)
            return i18n.finance.late_fee_frequency_weekly;
        else if(frequency == 15)
            return i18n.finance.late_fee_frequency_fortnightly;
        else if(frequency == 30)
            return i18n.finance.late_fee_frequency_monthly;
        else if(frequency == 60)
            return i18n.finance.late_fee_frequency_bi_monthly;
        else if(frequency == 90)
            return i18n.finance.late_fee_frequency_quarterly;
        else if(frequency == 180)
            return i18n.finance.late_fee_frequency_bi_annually;
        else if(frequency == 365)
            return i18n.finance.late_fee_frequency_annually;
    },

    getPaymentMethodDetail(payment_method, field){
        if (! payment_method)
            return false;

        field = "requires_"+field;
        if (payment_method.options && payment_method.options.hasOwnProperty(field))
            return payment_method.options[field] ? true : false;

        return false;
    },

    getAdmissionNumber(admission){
        let number = this.formatWithPadding(admission.number,this.getConfig('admission_number_digit'));
        return admission.prefix ? admission.prefix+''+number : number;
    },

    getTransferCertificateNumber(transfer_certificate){
        let number = this.formatWithPadding(transfer_certificate.number,this.getConfig('transfer_certificate_digit'));
        return transfer_certificate.prefix ? transfer_certificate.prefix+''+number : number;
    },

    getEmployeeCode(employee){
        return employee.prefix+''+this.formatWithPadding(employee.code,this.getConfig('employee_code_digit'))
    },

    getEmployeeName(employee){
        return employee.first_name+' '+(employee.middle_name ? employee.middle_name+' ' : '')+employee.last_name;
    },

    getEmployeeNameWithCode(employee){
        return employee.first_name+' '+(employee.middle_name ? employee.middle_name+' ' : '')+employee.last_name+' ('+employee.prefix+this.formatWithPadding(employee.code,this.getConfig('employee_code_digit'))+')';
    },

    getEmployeeDesignationOnDate(employee, date){
        date = (typeof date == 'undefined') ? moment().format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD');

        if(!employee.hasOwnProperty('employee_designations'))
            return '-';

        let employee_designation = employee.employee_designations.find(o => o.date_effective <= date && (o.date_end == null || (o.date_end >= date) ));

        if (typeof employee_designation == 'undefined')
            return '-';

        return employee_designation.designation.name+' ('+employee_designation.designation.employee_category.name+')';
    },

    getEmployeeDesignation(employee){
        if(!employee.hasOwnProperty('employee_designations'))
            return '-';

        let employee_designation = employee.employee_designations[employee.employee_designations.length-1];

        if (typeof employee_designation == 'undefined')
            return '-';

        return employee_designation.designation.name+' ('+employee_designation.designation.employee_category.name+')';
    },

    getEmployeeDesignationOnly(employee){
        if(!employee.hasOwnProperty('employee_designations'))
            return '-';

        let employee_designation = employee.employee_designations[employee.employee_designations.length-1];

        if (typeof employee_designation == 'undefined')
            return '-';

        return employee_designation.designation.name;
    },

    getEmployeeDateOfJoining(employee){
        if(!employee.hasOwnProperty('employee_terms'))
            return '-';

        let employee_term = employee.employee_terms[employee.employee_terms.length-1];

        if (typeof employee_term == 'undefined')
            return '-';

        return this.formatDate(employee_term.date_of_joining);
    },

    amIClassTeacherOnDate(class_teachers, date){
        date = (typeof date == 'undefined') ? moment().format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD');

        let class_teacher = class_teachers.find(o => o.date_effective <= date && o.is_me);

        if (typeof class_teacher == 'undefined')
            return false;

        let next_class_teacher = class_teachers.find(o => ! o.is_me && o.date_effective > class_teacher.date_effective && o.date_effective <= date);

        if (typeof next_class_teacher == 'undefined')
            return true;

        return false;
    },

    getStudentName(student){
        let last_name_first = this.getConfig('last_name_first');
        if(last_name_first) {
            return (student.last_name ? student.last_name+' ' : '')+ student.first_name+' '+(student.middle_name ? student.middle_name+' ' : '');
        } else{
            return student.first_name+' '+(student.middle_name ? student.middle_name+' ' : '')+(student.last_name ? student.last_name : '');
        }
    },

    getRollNumber(student_record){
        if (! student_record.roll_number)
            return;
        
        return student_record.roll_number;
        
        // if (! student_record.roll_number)
        //     return;
        
        // let roll_number = '';
        // if (student_record.batch.options.hasOwnProperty('roll_number_digit')) {
        //     roll_number = this.formatWithPadding(student_record.roll_number,student_record.batch.options.roll_number_digit);    
        // } else {
        //     roll_number = student_record.roll_number;
        // }

        // let prefix = student_record.batch.options.roll_number_prefix;
        
        // return prefix ? prefix+''+roll_number : roll_number;
    },

    getStudentBatchOnDate(student, date){
        date = moment(date).format('YYYY-MM-DD');

        if(!student.hasOwnProperty('student_records'))
            return '-';

        let student_record = student.student_records.find(o => o.date_of_entry <= date && !o.is_promoted);

        if (typeof student_record == 'undefined')
            return '-';

        return student_record.batch.course.name+' '+student_record.batch.name;
    },

    getVoucherNumber(transaction){
        return (transaction.prefix ? transaction.prefix : '')+transaction.number;
    },

    getPayHeadNameWithAlias(pay_head){
        return pay_head.name+' ('+pay_head.alias+')';
    },

    getExcerpts(content){
        return content.replace(/<[^>]+>/g, '');
    },

    truncateWords(text, length, suffix){
        var trimmedString = text.substr(0, length);
        return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))) + suffix;
    },

    truncateLetters(text, length, suffix){
        return text.replace(new RegExp("^(.{"+length+"}[^\s]*).*"), "$1") + suffix;
    },

    getPayrollNumber(payroll){
        return this.formatWithPadding(payroll.id,3);
    },

    frontendConfigurationAccessible(){
        return helper.hasPermission('configure-frontend');
    },

    getAuthToken(){
        return Vue.cookie.get('auth_token');
    },
    
    getDbname(){
        return Vue.cookie.get('x-connection-object');
    },

    showDemoNotification(items){
        if(this.getConfig('mode'))
            return;

        if(Vue.cookie.get('hide_school_portal_tour'))
            return;

        for (let i = 0; i < items.length; i++) {
            let item = items[i];

            let cookie_name = 'school_portal_notification_' + item;

            if (Vue.cookie.get(cookie_name))
                continue;

            if(!notificationJSON.hasOwnProperty(item))
                continue;

            Vue.notify({
              group: 'demo',
              clean: true
            });
            
            Vue.notify({
              group: 'demo',
              title: notificationJSON[item].title,
              nextUrl: '/student/admission',
              text: notificationJSON[item].message,
              duration: 120000
            })

            Vue.cookie.set(cookie_name, this.randomString(20) , {expires: '30m'});
            break;
        }
    },
    
    // to get Auth user employee
    getAuthUserEmployee(name){
        return store.getters.getAuthUserEmployee(name);
    }
}



// WEBPACK FOOTER //
// resources/js/services/helper.js